import { Navigate, type NavigateProps, generatePath } from 'react-router';

import { useMe } from '@/providers/User';

const InstanceNavigate = ({ to, ...rest }: NavigateProps) => {
  const user = useMe();
  const instanceSlug = user?.currentOrg.instanceId.replace(/^inst:/, '');

  if (typeof to === 'string') {
    return <Navigate {...rest} to={generatePath(to, { instance: instanceSlug })} />;
  }

  return (
    <Navigate
      {...rest}
      to={{
        ...to,
        pathname: to.pathname ? generatePath(to.pathname, { instance: instanceSlug }) : undefined,
      }}
    />
  );
};

export default InstanceNavigate;
